import React from 'react';
import { Outlet } from 'react-router-dom';

function PublicLayout() {
    return (
        <div className="page-wrapper">
            {/* Header e menu verranno gestiti manualmente dal codice esistente */}
            
            <main className="main-content">
                <Outlet />
            </main>

            <footer className="site-footer">
                <div className="footer-container">
                    <div className="footer-logo">
                        <img src="/logo.png" alt="Evomotor Logo" style={{ height: 80, width: 'auto' }} />
                    </div>
                    <div className="footer-text">
                        <p>© 2026 Evomotor. Tutti i diritti riservati. Evomotor è un marchio registrato.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default PublicLayout;
